var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C12.1684 0 11.4561 0.506724 11.1543 1.22852L0.300781 19.9473V19.9492C0.104902 20.2648 0.000752159 20.6286 0 21C0 21.5304 0.210714 22.0391 0.585786 22.4142C0.960859 22.7893 1.46957 23 2 23C2.04693 22.9997 2.09383 22.9977 2.14062 22.9941L2.14453 23H13H23.8555L23.8594 22.9922C23.9061 22.9964 23.953 22.999 24 23C24.5304 23 25.0391 22.7893 25.4142 22.4142C25.7893 22.0391 26 21.5304 26 21C25.9996 20.6279 25.8954 20.2634 25.6992 19.9473L25.6836 19.9199C25.6829 19.9193 25.6823 19.9186 25.6816 19.918L14.8457 1.22852C14.5439 0.506724 13.8316 0 13 0ZM11.7871 8.35938H14.2129L14.0117 14.832H11.9883L11.7871 8.35938ZM13.0039 16.8105C13.8259 16.8105 14.3184 17.2528 14.3184 18.0078C14.3184 18.7488 13.8259 19.1895 13.0039 19.1895C12.1759 19.1895 11.6797 18.7488 11.6797 18.0078C11.6797 17.2528 12.1749 16.8105 13.0039 16.8105Z",
    fill: "#E25563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.b2c0b4ec29a36c0b34478f1d89a9e2cc.svg";
export { ForwardRef as ReactComponent };